import React from "react";
import { withRouter } from "react-router-dom";
import { menuDataResponse } from "../../LeftMenu/jsonMenu";
import { Grid, Paper, IconButton } from "@material-ui/core";

//import { makeStyles } from "@material-ui/styles";
import MaterialIcon from "../../materialIcon/materialIcon";
import useStyles from "./style";

const Favorites = (props) => {
  const classes = useStyles();
  const name = JSON.parse(localStorage.getItem("state"));
  const permissions = name?.permissions;

  return (
    <div style={{ marginTop: "25px" }}>
      Favorites
      <React.Fragment>
        <Grid item xs={12} sm={6} md={6} lg={7}>
          <h1 className={classes.styleTitles}>Atajos</h1>
          <Grid container spacing={3} direction="row">
            {menuDataResponse?.menus?.map((menu) => (
              <React.Fragment key={menu.id}>
                {(menu?.code === "HV" || menu?.code === "VAC" ||
                  permissions?.some((x) => x?.code === menu?.code)) &&
                  !menu?.subMenus && (
                    <Grid item xs={12} sm={6} md={6} lg={2}>
                      <Paper elevation={2} className={classes.containerAtajos}>
                        <IconButton className={classes.icon}>
                          <MaterialIcon fill="outlined" name={menu?.icon} />
                        </IconButton>
                        <h1 className={classes.titleAcces}>{menu?.title}</h1>
                      </Paper>
                    </Grid>
                  )}
                {menu?.subMenus
                  ? menu?.subMenus?.map((sub) => (
                      <React.Fragment>
                        {permissions.some((x) => x.code === sub?.code) && (
                          <Grid item xs={12} sm={6} md={6} lg={2}>
                            <Paper
                              elevation={2}
                              className={classes.containerAtajos}
                            >
                              <IconButton className={classes.icon}>
                                <MaterialIcon
                                  fill="outlined"
                                  name={sub?.icon}
                                />
                              </IconButton>
                              <h1 className={classes.titleAcces}>
                                {sub?.title}
                              </h1>
                            </Paper>
                          </Grid>
                        )}
                      </React.Fragment>
                    ))
                  : null}
              </React.Fragment>
            ))}
          </Grid>
        </Grid>
      </React.Fragment>
    </div>
  );
};

export default withRouter(Favorites);
